import { jsx as _jsx } from "react/jsx-runtime";
import { ExpandableSection, capitalize } from '@patternfly/react-core';
import { useEffect, useState } from 'react';
const WHITESPACE_REGEX = /\s/g;
export const CustomExpandableSection = ({ groupName, isGroupExpanded = false, children, }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    useEffect(() => {
        setIsExpanded(isGroupExpanded);
    }, [isGroupExpanded]);
    const onToggle = (_event, isExpanded) => {
        setIsExpanded(isExpanded);
    };
    return (_jsx(ExpandableSection, { toggleText: capitalize(`${groupName} properties`), toggleId: `expandable-section-toggle-${groupName.replace(WHITESPACE_REGEX, '-')}`, contentId: "expandable-section-content", onToggle: onToggle, isExpanded: isExpanded, children: children }));
};
//# sourceMappingURL=CustomExpandableSection.js.map